import { Accordion as AccordionPrimitive } from "radix-ui";
import type { ComponentProps } from "react";

export const Accordion = (props: ComponentProps<typeof AccordionPrimitive.Root>) => (
  <AccordionPrimitive.Root data-slot="accordion" {...props} />
);
